import React, { useCallback } from 'react'
import { useParams } from 'react-router-dom'

import { Layout } from 'admin/lib/Layouts'
import { Breadcrumb, BreadcrumbArrayItem } from 'admin/lib/Breadcrumbs'
import { useApiQuery } from 'admin/lib/Api'
import { EditCertificate } from './EditCertificate'
import { ScreenSpin } from 'admin/lib/ScreenSpin'

import * as ROUTES from 'admin/routes'

export function Certificate() {
  const { certificateId } = useParams()

  const certificate = useApiQuery(
    useCallback(
      api => {
        if (certificateId === 'register') {
          return [{}, null, null]
        }
        return api.getCertificate(certificateId)
      },
      [certificateId]
    )
  )

  return (
    <Layout
      header={
        <Breadcrumb
          items={[
            {
              title: (
                <BreadcrumbArrayItem href={ROUTES.REFERENCE_DATA.INDEX}>
                  Reference Data
                </BreadcrumbArrayItem>
              )
            },
            {
              title: (
                <BreadcrumbArrayItem href={ROUTES.CERTIFICATES.LIST}>
                  Certificates
                </BreadcrumbArrayItem>
              )
            },
            {
              title: certificateId
            }
          ]}
        />
      }
    >
      {!certificate.loaded && <ScreenSpin />}

      {certificate.loaded && (
        <EditCertificate
          certificate={certificate.data}
          isNew={certificateId === 'register'}
        />
      )}
    </Layout>
  )
}
